<textarea (ngModelChange)="textAreaChanged($event)" matInput
          [(ngModel)]="acModel"
          [disabled]="ngDisabled | acFunc : validatorsService.isFieldDisabled : acInputContainerComponent?.isDisabled : acFormComponent?.isDisabled"
          [attr.maxlength]="maxLength?maxLength:null"
          [attr.placeholder]="placeHolderText?placeHolderText:null"
          [attr.rows]="visibleRows?visibleRows:1"
          [id]="textAreaId"
          class="ac-textarea">
</textarea>
